import { render, staticRenderFns } from "./TypeValidationForm.vue?vue&type=template&id=9f76d5d0"
import script from "./TypeValidationForm.vue?vue&type=script&lang=js"
export * from "./TypeValidationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports